import { lazy } from "react"

export const LazyCodeBlock = lazy(() =>
  import("./CodeBlock").then((module) => ({
    default: module.CodeBlock,
  })),
)
